import FaqContent from 'js/pages/faqs/_faq-content.js'
import FaqSectionsIcons from 'js/pages/faqs/_faq-sections-icons.js'

import Faq from './_faq'

import template from './index.pug'

export default Vue.extend({
  name: 'faqs-page',
  template: template(),
  components: {
    Faq
  },

  data() {
    return {
      selectedSectionId: undefined
    }
  },

  computed: {
    // Carga del FAQ
    faqs() {
      return FaqContent.map(faq => ({
        id: faq.id,
        section: faq.section,
        question: this.$t(`faqs.faqs.${faq.section}.${faq.id}.question`),
        answer: this.$t(`faqs.faqs.${faq.section}.${faq.id}.answer`),
        instagram: faq.instagram,
        visible: false
      }))
    },

    sectionsSet() {
      return [...new Set(this.faqs.map(faq => faq.section))]
    },

    faqsSections() {
      return this.sectionsSet.map(section => ({
        icon: FaqSectionsIcons[section],
        id: `faq-section-${section}`,
        label: this.$t(`faqs.sections.${section}.title`),
        title: this.$t(`faqs.sections.${section}.title`),
        description: this.$t(`faqs.sections.${section}.description`),
        value: section,
        active: this.selectedSectionId === section
      }))
    },

    /*
      Necesito usar un array con objetos con solamente label y value porque el array que devuelve
      faqsSections no funciona correctamente con el selector. No me permite cambiar de opción.
    */
    faqsOptions() {
      return this.sectionsSet.map(section => ({
        label: this.$t(`faqs.sections.${section}.title`),
        value: section
      }))
    },

    selectedSection() {
      if (this.selectedSectionId) {
        return this.faqsSections.find(section => section.value === this.selectedSectionId)
      }
      return undefined
    },

    filteredFaqs() {
      return this.faqs.map(faq => {
        const newFaq = _.clone(faq)
        newFaq.visible = (faq.section === this.selectedSectionId)
        return newFaq
      })
    }
  },

  created() {
    this.selectedSectionId = (this.faqsSections[0] || {}).value
  },

  mounted() {
    this.reloadInstagram()
  },

  methods: {
    step(index) {
      this.selectedSectionId = (this.faqsSections[index] || {}).value
    },

    reloadInstagram() {
      if (window && window.instgrm) {
        window.instgrm.Embeds.process()
      }
    }
  }
})
